import ClientOnly from '@/components/ClientOnly';
import EmbedLayout from '@/components/widget/Layout';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

// Hidden Chart Preview off-screen
// Renders the chart preview in the background
// to create the image for download
const ChartPreview = _ref => {
  let {
    widget,
    workbook,
    workbookMeta,
    previewIndex = -1,
    updatedAt,
    layoutWidth = 1000,
    layoutHeight = 1000,
    previewCanvasRef
  } = _ref;
  const widgetId = `${widget.id || ''}-share`;
  return /*#__PURE__*/_jsx("div", {
    className: styles.container,
    children: /*#__PURE__*/_jsx("div", {
      ref: previewCanvasRef,
      className: styles.container__preview,
      style: {
        width: `${layoutWidth}px`,
        height: `${layoutHeight}px`
      },
      children: /*#__PURE__*/_jsx(ClientOnly, {
        children: /*#__PURE__*/_jsx(EmbedLayout, {
          // Force re-render on video generation
          widgetId: widgetId,
          reportingWidgetId: widgetId,
          workbook: workbook,
          workbookMeta: workbookMeta,
          updatedAt: updatedAt,
          config: widget.config,
          sections: widget.sections || {},
          subscriptionActive: true // Hide accreditation

        }, previewIndex)
      })
    })
  });
};

export default ChartPreview;